module.exports = __webpack_public_path__ + "img/search-icon.f987bd66.svg";